import { render } from "./quotationDetails.vue?vue&type=template&id=426ef15e&scoped=true"
import script from "./quotationDetails.vue?vue&type=script&lang=js"
export * from "./quotationDetails.vue?vue&type=script&lang=js"

import "./quotationDetails.vue?vue&type=style&index=0&id=426ef15e&lang=less&scoped=true"

import exportComponent from "F:\\LSDC\\trunk\\lsdc-delivery-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426ef15e"]])

export default __exports__